import { defineWidget } from '../widget-types';

/**
 * Block — one atom (text, button, image, spacer, divider, icon…) placed directly in a stack, so a
 * container's `children` can mix atoms and nested containers in ONE ordered list (lego step 1).
 * The atom itself is the existing BlockContent (schema/block-types.ts), rendered live by the store's
 * existing block content renderer; its box inside the stack is StackItemBox (utils/stack-style.ts).
 *
 * props: { content: BlockContent, widthMode?, widthPx?, heightMode?, heightPx? }
 */
export const blockWidget = defineWidget({
  type: 'block',
  schema: {
    label: 'Element',
    description: 'A single element (text, button, image…) inside a container',
    props: {
      widthMode: { type: 'enum', label: 'Width', options: ['fill', 'hug', 'fixed'] },
      widthPx: { type: 'number', label: 'Width (px)', min: 0, max: 4000 },
      heightMode: { type: 'enum', label: 'Height', options: ['fill', 'hug', 'fixed'] },
      heightPx: { type: 'number', label: 'Height (px)', min: 0, max: 4000 },
    },
    dataDeps: [],
  },
  nameTh: 'องค์ประกอบ',
  descriptionTh: 'องค์ประกอบเดียว (ข้อความ ปุ่ม รูปภาพ…) ภายในคอนเทนเนอร์',
  category: 'layout',
  thumbnail: '/widget-thumbnails/container-frame.svg',
  defaults: {
    type: 'block',
    props: { content: { type: 'text', value: 'Text' } },
  },
});
